import React from 'react';
// COMPONENTS
import ModalAddToList from 'components/ModalAddToList';
import CreateNewList from 'components/CreateNewList';
import ModalAddress from "components/ModalAddress"
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDeliverySelector from 'components/ModalDeliverySelector';
import ModalLogin from 'components/ModalLogin';
import ModalPassword from "components/ModalPassword";
import ModalRegister from 'components/ModalRegister';
import ModalFeedbackRegister from 'components/ModalFeedbackRegister';
import ModalError from 'components/ModalError';
import ModalProductInCart from 'components/ModalProductInCart';
import ModalValidationCode from "components/ModalValidationCode";
import ProductPreview from 'components/ProductPreview';
import ModalPersistsAddress from "components/ModalPersistsAddress";
import ModalLostProducts from 'components/ModalLostProducts';
import ModalProductsCart from 'components/Checkout/ModalProductsCart';
import NotificationContent from 'components/NotificationContent';
import ModalUserInfo from 'components/ModalUserInfo';
import ModalReschedule from 'components/ModalReschedule';
import ModalConfirmReschedule from 'components/ModalConfirmReschedule';
import BannerHour from 'components/Header/BannerHour';
import ModalNewFeature from 'components/ModalNewFeature';
import ModalDateDelivery from 'components/Checkout/CheckoutSteps/DeliveryMode/DateDelivery/ModalDateDelivery';
import ModalOrderCancelSuccess from 'components/ModalOrderCancelSuccess';
import ModalTermsConditions from 'components/ModalTermsConditions';
import style from './style.scss';//NOSONAR

const GeneralContent = () => {
    return (
        <div className='general-content-page'>
            <ModalLogin />
            <ModalPassword />
            <ModalValidationCode />
            <ModalRegister />
            <ModalFeedbackRegister />
            <ModalError />
            <ModalAddress />
            <ModalDeliverySelector />
            <ModalProductInCart />
            <ModalAddToList />
            <CreateNewList />
            <ProductPreview />
            <ModalConfirmation />
            <ModalLostProducts />
            <ModalPersistsAddress/>
            <NotificationContent />
            <ModalProductsCart/>
            <BannerHour />
            <ModalUserInfo />
            <ModalNewFeature />
            <ModalReschedule />
            <ModalConfirmReschedule />
            <ModalDateDelivery/>
            <ModalOrderCancelSuccess />
            <ModalTermsConditions />
        </div>
    )
    
}
export default GeneralContent;
